import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { ar, en } from '@/lib/translations';
import { repairArabicMojibake } from '@/lib/utils';

const translations = { ar, en };

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('bf_lang') || 'en');

  // Apply dir and lang on initial load AND whenever lang changes
  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = useCallback(() => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    setLang(newLang);
    localStorage.setItem('bf_lang', newLang);
  }, [lang]);

  const setLanguage = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('bf_lang', newLang);
  }, []);

  const t = useCallback((key) => {
    return repairArabicMojibake(translations[lang]?.[key] || translations['en']?.[key] || key);
  }, [lang]);

  const isRTL = lang === 'ar';

  return (
    <LangContext.Provider value={{ lang, setLang: setLanguage, toggleLang, t, isRTL }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
};
